export const empty = "";

export const isNullOrWhiteSpace = (value: string): boolean =>
  typeof value === "undefined" || value === null || value.trim() === "";

export const nameOf = <T>(name: keyof T): string | number | symbol => name;
